// extracted by mini-css-extract-plugin
module.exports = {"primary":"#5576d1"};